module.exports = __webpack_public_path__ + "static/media/SDFSA_3-960w.d7f6fe4e.jpg";